
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/hosting/plan",
      function () {
        return require("private-next-pages/dashboard/hosting/plan.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/hosting/plan"])
      });
    }
  